/**
 * @file filterContext.js
 * @description This file contains the context and provider for managing filter state in the application.
 */

import { createContext, useState } from 'react';

/**
 * @typedef {Object} FilterContextType
 * @property {string} filterState - The current state of the filter.
 * @property {Function} setFilterState - Function to update the filter state.
 */

/**
 * @type {React.Context<FilterContextType>}
 */
export const FilterContext = createContext({
  filterState: 'true',
  setFilterState: () => {},
});

/**
 * @component
 * @param {Object} props - The component props.
 * @param {React.ReactNode} props.children - The child components that will have access to the filter context.
 * @returns {JSX.Element} The provider component that supplies the filter context to its children.
 */
export const FilterProvider = ({ children }) => {
  const [filterState, setFilterState] = useState('true');
  return (
    <FilterContext.Provider value={{ filterState, setFilterState }}>
      {children}
    </FilterContext.Provider>
  );
};